
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 51 52","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_718_238)"}},[_c('circle',{attrs:{"cx":"25.333","cy":"24.269","r":"16.15","fill":"#F9A91E"}})]),_c('path',{attrs:{"fill":"#000","d":"M23.301 16.154h4.404v16.884h-4.404z"}}),_c('path',{attrs:{"fill":"#000","d":"M33.942 22.453v4.404H17.058v-4.404z"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_718_238","x":".068","y":".827","width":"50.531","height":"50.53","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"1.823"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"4.558"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_718_238"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_718_238","result":"shape"}})])])])
          )
        }
      }
    